export const SET_LIST = 'SET_LIST';
export const SET_CURRENT_LIST = 'SET_CURRENT_LIST';
export const SET_START_INDEX = 'SET_START_INDEX';
